module.exports = __webpack_public_path__ + "img/enterprise-competition-2024-schedule-open-group-semi-finals-1.44c3e4ee.jpg";